module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-04.70a1466e.jpg";